import React, {useState, useEffect} from 'react';
import * as S from './style';
import {
	Button,
	DatePicker,
	Form,
	Image,
	Input,
	Modal,
	Space,
	Table,
} from 'antd';
import dayjs from 'dayjs';
import {Container} from '../../../Components/Atom';
import {
	createModal,
	deleteModal,
	getInfo,
	getModals,
	updateInfo,
	updateModal,
} from '../../../api/admin';
import {AiOutlineDropbox} from 'react-icons/ai';
import Dragger from 'antd/es/upload/Dragger';
import {noImage} from '../../../config/images';
import styled from 'styled-components';

const dateFormat = 'YYYY-MM-DD';
const datetimeFormat = 'YYYY-MM-DD HH:mm:ss';

const AdminInfo = () => {
	const [info, setInfo] = useState({
		id: 0,
		name: '',
		started: '',
		ended: '',
		volunteer_ended: '',
		ten_num: 0,
		five_num: 0,
	});
	const [isLoading, setIsLoading] = useState(true);
	const [modal, setModal] = useState(false);
	const [fileList, setFileList] = useState([]);
	const [modals, setModals] = useState([]);
	const [toggle, setToggle] = useState(false);

	const props = {
		multiple: true,
		onRemove: (file) => {
			const index = fileList.indexOf(file);
			const newFileList = fileList.slice();
			newFileList.splice(index, 1);
			setFileList(newFileList);
		},
		beforeUpload: (file) => {
			setFileList([...fileList, file]);
			return false;
		},
		fileList,
	};

	useEffect(() => {
		(async () => {
			let res = await getInfo();
			let modal_res = await getModals({isAdmin: true});
			if (!res.isSuccess || res.data.count !== 1) {
				return alert(
					'현재 정보가 잘못 설정되었습니다. 사무국으로 문의해주세요',
				);
			}

			if (!modal_res.isSuccess) {
			}
			setModals(modal_res.data.results);

			setInfo({
				...res.data.results[0],
			});
			setIsLoading(false);
		})();
	}, [toggle]);

	return (
		<>
			{isLoading && <></>}
			{!isLoading && (
				<S.Container style={{padding: '10px 20px'}}>
					<Title>대회정보 관리</Title>
					<Form
						initialValues={{
							name: info.name,
							started: dayjs(info.started, 'YYYY-MM-DD'),
							ended: dayjs(info.ended, 'YYYY-MM-DD HH:mm:ss'),
							volunteer_ended: dayjs(info.volunteer_ended, 'YYYY-MM-DD HH:mm:ss'),
							ten_num: info.ten_num,
							five_num: info.five_num,
						}}
						onFinish={async (values) => {
							let started = values.started.format(dateFormat);
							let ended = values.ended.format(datetimeFormat);
							let volunteer_ended = values.volunteer_ended.format(datetimeFormat);

							await updateInfo({
								name: values.name,
								started,
								ended,
								volunteer_ended,
								id: info.id,
								ten_num: values.ten_num,
								five_num: values.five_num,
							});
							alert('수정완료');
						}}
					>
						<Form.Item name={'name'} label={'대회 이름'}>
							<Input />
						</Form.Item>
						<Form.Item label={'대회 기간'} style={{ marginBottom: 0 }}>
							<div
								style={{
									display: 'flex',
									justifyContent: 'space-between',
									alignItems: 'baseline',
								}}
							>
								<Form.Item
									name={'started'}
									style={{width: '48%'}}
								>
									<DatePicker
										style={{width: '100%'}}
										dateFormat={dateFormat}
									/>
								</Form.Item>
								~
								<Form.Item
									name={'ended'}
									style={{width: '48%'}}
								>
									<DatePicker
										showTime
										style={{width: '100%'}}
										dateFormat={datetimeFormat}
									/>
								</Form.Item>
							</div>{' '}
						</Form.Item>
						<Form.Item label={'봉사신청마감'} style={{ marginBottom: 0 }}>
							<Form.Item
								name={'volunteer_ended'}
								style={{width: '100%'}}
							>
								<DatePicker
									showTime
									style={{width: '100%'}}
									dateFormat={datetimeFormat}
								/>
							</Form.Item>
						</Form.Item>
						<Form.Item label={'제한 인원(숫자)'}>
							<div style={{ display: 'flex', gap: '12px' }}>
								<Form.Item name={'ten_num'} label={'10.19km코스'} style={{ marginBottom: 0 }}>
									<Input />
								</Form.Item>
								<Form.Item name={'five_num'} label={'5km코스'} style={{ marginBottom: 0 }}>
									<Input />
								</Form.Item>
							</div>
							<div
								style={{
									display: 'flex',
									justifyContent: 'flex-end',
								}}
							>
								<Button type={'default'} htmlType={'수정'}>
									수정
								</Button>
							</div>
						</Form.Item>
					</Form>
					<Title>팝업관리(최대 2개 가능)</Title>
					<div
						style={{
							display: 'flex',
							justifyContent: 'flex-end',
							marginBottom: 20,
						}}
					>
						<Button
							onClick={() => {
								setModal(true);
							}}
						>
							팝업 생성
						</Button>
					</div>

					<Table dataSource={modals} scroll={{x: 500}}>
						<Table.Column
							title={'이미지'}
							align={'center'}
							render={(value, record, index) => (
								<Image
									width={100}
									src={record.image}
									fallback={noImage}
								/>
							)}
						/>
						<Table.Column
							title={'활성화여부'}
							align={'center'}
							render={(value, record) => {
								return record.is_active ? '활성화' : '비활성화';
							}}
						/>
						<Table.Column
							title={'액션'}
							align={'center'}
							render={(value, record, index) => {
								return (
									<Space>
										<Button
											onClick={async () => {
												await updateModal({
													id: record.id,
													is_active:
														!record.is_active,
												});

												setToggle(!toggle);
											}}
										>
											활성화/비활성화
										</Button>
										<Button
											onClick={async () => {
												await deleteModal({
													id: record.id,
												});
												setToggle(!toggle);
											}}
										>
											삭제
										</Button>
									</Space>
								);
							}}
						/>
					</Table>
					{modal && (
						<Modal
							open={modal}
							footer={[]}
							onCancel={() => setModal(false)}
						>
							<Dragger {...props} style={{margin: '1rem 0'}}>
								<p className='ant-upload-drag-icon'>
									<AiOutlineDropbox />
								</p>
								<p className='ant-upload-text'>
									파일을 드래그 혹은 클릭하여 선택해주세요
								</p>
								<p className='ant-upload-hint'>
									해당 이미지는 등록 후 활성화를 해야지 사용이
									가능합니다.
								</p>
							</Dragger>
							<div
								style={{
									display: 'flex',
									justifyContent: 'flex-end',
								}}
							>
								<Button
									onClick={async () => {
										let res = await createModal({
											image: fileList[0],
										});

										if (res.status === 201) {
											setModal(false);
											setToggle(!toggle);
											return;
										}

										return alert('문제가 발생하였습니다.');
									}}
								>
									팝업 생성
								</Button>
							</div>
						</Modal>
					)}
				</S.Container>
			)}
		</>
	);
};

export default AdminInfo;

const Title = styled.p({
	textAlign: 'center',
	fontWeight: 'bold',
	marginBottom: 50,
});
